import { render, staticRenderFns } from "./StageSalaryEdit.vue?vue&type=template&id=4c801273&scoped=true&"
import script from "./StageSalaryEdit.vue?vue&type=script&lang=js&"
export * from "./StageSalaryEdit.vue?vue&type=script&lang=js&"
import style0 from "./SalaryStage.css?vue&type=style&index=0&id=4c801273&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c801273",
  null
  
)

export default component.exports